import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SituFurnishMenuDialogComponent } from '../situ-furnish-menu-dialog/situ-furnish-menu-dialog.component';
import { ICompany } from 'identity-webapi-client';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription } from 'rxjs';

@Component({
  selector: 'situ-furnish-menu',
  templateUrl: './situ-furnish-menu.component.html',
  styleUrls: ['./situ-furnish-menu.component.less']
})
export class SituFurnishMenuComponent implements OnInit, OnDestroy, OnChanges {
  /* standard */
  @Input() isAdmin: boolean = false;
  @Input() isSituUser: boolean = false;
  @Input() isDarkMode: boolean = false;

  @Input() startOpened: boolean = false;
  @Input() company: ICompany | undefined;
  @Input() home: string | undefined;
  @Input() ifcFiles: string | undefined;

  @Output() selectedHomeIfcFileId: EventEmitter<string> = new EventEmitter();

  dialogRef: MatDialogRef<SituFurnishMenuDialogComponent> | undefined;
  deviceSm: boolean = false;
  
  private _subscriptions: Subscription[] = [];

  constructor(
    private dialog: MatDialog,
    private mediaObserver: MediaObserver
  ) {}
  
  ngOnInit(): void {
    if (this.startOpened) {
      this.openDialog();
    }
  }

  ngOnDestroy(): void {
    if (this._subscriptions) {
      this._subscriptions.forEach(subscription => {
        if (subscription) {
          subscription.unsubscribe();
        }
      })
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.company && !changes.company.isFirstChange() && changes.company.currentValue) {
      if (this.dialogRef) {
        this.dialogRef.close();
      }
    }
    this._subscriptions.push(this.mediaObserver.asObservable().subscribe((result: MediaChange[]) => {
      const mqAlis = result.some(change => change.mqAlias === 'xs' || change.mqAlias === 'sm');
      if (this.deviceSm !== mqAlis) {
        this.deviceSm = mqAlis;
        if (this.deviceSm) {
          this.dialogRef?.updateSize('100%', '80%');
        } else {
          this.dialogRef?.updateSize('60%', '80%');
        }
      } 
    }));
  } 

  openDialog() {
    this.dialogRef = this.dialog.open(SituFurnishMenuDialogComponent, {
      panelClass: 'modal-panel',
      width: this.deviceSm ? '100%' : '60%',
      height: this.deviceSm ? '100%' : '80%',
      data: {
        company: this.company,
        home: this.home,
        ifcFiles: this.ifcFiles
      }
    });

    this._subscriptions.push(this.dialogRef.afterClosed().subscribe(homeIfcFileId => {
      if (homeIfcFileId) {
        this.selectedHomeIfcFileId.emit(homeIfcFileId);
      }
    }));
  }
}
